import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { authGuard } from './core/auth.guard';
import { adminGuard } from './core/admin.guard';
import { MainLayoutComponent } from './main-layout/main-layout.component';
import { roleRedirectGuard } from './core/role-redirect.guard';
import { superAdminGuard } from './core/super-admin.guard';
import { unsavedChangesGuard } from './core/unsaved-changes.guard';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  {
    path: 'super-admin',
    loadComponent: () =>
      import(
        './super-admin/super-admin-main-layout/super-admin-main-layout.component'
      ).then((m) => m.SuperAdminMainLayoutComponent),
    canActivate: [authGuard, superAdminGuard],
    children: [
      {
        path:'',
        redirectTo:'tenants',
        pathMatch:'full'
      },
      {
        path: 'tenants',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./super-admin/tenants-page/tenants-page.component').then(
                (m) => m.TenantsPageComponent
              ),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./super-admin/tenant-page/tenant-page.component').then(
                (m) => m.TenantPageComponent
              ),
              
            children: [
              {
                path: 'overview',
                loadComponent: () =>
                  import(
                    './super-admin/tenant-overview/tenant-overview.component'
                  ).then((m) => m.TenantOverviewComponent),
              },
              {
                path: 'modules',
                loadComponent: () =>
                  import(
                    './super-admin/tenant-modules/tenant-modules.component'
                  ).then((m) => m.TenantModulesComponent),
                canDeactivate: [unsavedChangesGuard],
              },
              {
                path: 'management',
                loadComponent: () =>
                  import(
                    './super-admin/tenant-management/tenant-management.component'
                  ).then((m) => m.TenantManagementComponent),
              },
              {
                path: '',
                redirectTo: 'overview',
                pathMatch: 'full',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: '',
    canActivate: [authGuard, roleRedirectGuard],
    component: MainLayoutComponent,
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./dashboard/dashboard.component').then(
            (m) => m.DashboardComponent
          ),
      },
      {
        path: 'products',
        loadComponent: () =>
          import('./products/products.component').then(
            (m) => m.ProductsComponent
          ),
      },
      {
        path: 'products/new',
        loadComponent: () =>
          import('./products/product-edit/product-edit.component').then(
            (m) => m.ProductEditComponent
          ),
      },
      {
        path: 'products/:id',
        loadComponent: () =>
          import('./products/product-edit/product-edit.component').then(
            (m) => m.ProductEditComponent
          ),
      },
      {
        path: 'media',
        loadComponent: () =>
          import('./media/media.component').then((m) => m.MediaComponent),
      },
      {
        path: 'orders',
        loadComponent: () =>
          import('./orders/orders.component').then((m) => m.OrdersComponent),
      },
      {
        path: 'statistics',
        children: [
          {
            path: '',
            loadComponent: () => import('./statistics/statistics.component').then(m => m.StatisticsComponent),
          },
          {
            path: 'abc-analysis',
            loadComponent: () => import('./statistics/abc-page/abc-page.component').then(m => m.AbcPageComponent)
          }
        ]
      },
      {
        path: 'loyalty-program',
        loadComponent: () => import('./loyalty-programs/loyalty-programs.component').then(m => m.LoyaltyProgramsComponent),
        children: [
          {
            path: '',
            redirectTo: 'types',
            pathMatch: 'full'
          },
          {
            path: 'types',
            loadComponent: () => import('./loyalty-programs/loyalty-program-types/loyalty-program-types.component').then(m => m.LoyaltyProgramTypesComponent),
          },
          {
            path: 'earnings',
            loadComponent: () => import('./loyalty-programs/loyalty-program-earnings/loyalty-program-earnings.component').then(m => m.LoyaltyProgramEarningsComponent),
          },
          {
            path: 'rewards',
            loadComponent: () => import('./loyalty-programs/loyalty-program-rewards/loyalty-program-rewards.component').then(m => m.LoyaltyProgramRewardsComponent),
          },
        ],
        
      },
      {
        path: 'customer-cards',
        loadComponent: () =>
          import('./customer-cards/customer-cards.component').then(
            (m) => m.CustomerCardsComponent
          ),
      },
      {
        path: 'push-notifications',
        loadComponent: () =>
          import('./push-notifications/push-notifications.component').then(
            (m) => m.PushNotificationsComponent
          ),
      },
      {
        path: 'options',
        
        children: [
          {
            path: 'business-hours',
            loadComponent: () => import('./options/business-hours/business-hours.component').then(m => m.BusinessHoursComponent)
          },
          {
            path: '',
            loadComponent: () => import('./options/options.component').then(m => m.OptionsComponent),
          }
        ]
      },
      {
        path: 'logs',
        loadComponent: () =>
          import('./logs/logs.component').then((m) => m.LogsComponent),
        canActivate: [adminGuard],
      },
      {
        path: 'invoices',
        loadComponent: () =>
          import('./invoices/invoices.component').then(
            (m) => m.InvoicesComponent
          ),
      },
      {
        path: 'filters',
        loadComponent: () =>
          import('./filters/filters-page.component').then(
            (m) => m.FiltersPageComponent
          ),
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
    ],
  },
  { path: '**', redirectTo: '' }, // Wildcard route for a 404 or redirect to home
];
